<div class="contains-button">
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config   [device]="device"   [elementChoosing]="objectChoosing" [width]="class['map']['width']" [height]="class['map']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul style="padding: 0" nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li nz-submenu nzTitle="{{'vi_tri' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <ng-container >
          <nz-radio-group [(ngModel)]="radioValue">
            <label nz-radio nzValue="location">{{'nhap_dia_chi' | translate}} </label>
            <label nz-radio nzValue="iframe">{{'dung_the_nhung' | translate}}</label>
          </nz-radio-group>
          <!-- Thêm địa chỉ bằng cách nhập -->
          <div class="container-font" *ngIf="radioValue == 'location'">
            <div class="config-text" style="width:100%">
              <mat-form-field style="width:100%">
                <mat-label>{{'nhap_dia_chi' | translate}} </mat-label>
                <textarea matInput [(ngModel)]="staticdata.local" (blur)="getLocal(staticdata.local)" ></textarea>
              </mat-form-field>
            </div>
          </div>
          <!-- Thêm địa chỉ bằng iframe -->
          <div *ngIf="radioValue == 'iframe'" class="map__item--change-link">
            <div>
              <input #myInput nz-input [placeholder]="placeHolder" [ngClass]="{'invalid':wrong}"
                class="input_iframe form-group" nzSize="large" [(ngModel)]="srcInput" />
            </div>
            <div class="map__item--change-link--button d-flex flex-column">
              <button class="mb-1 buttons-map" style="  background-color: white !important;
            border : 2px solid #00a859;
            color: #00a859;" nz-button nzType="primary" (click)="showModal()">
                <span style="line-height:15px; white-space: normal">{{'huong_dan_chen_ban_do' | translate}}</span>
              </button>
              <button nz-button nzType="primary" (click)="getLink(srcInput)">{{'CAP_NHAT' | translate}}</button>
            </div>
          </div>
        </ng-container>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['map__iframe']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[0])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- TỐI ƯU CHỈ SỐ HỖ TRỢ TIẾP CẬN -->
      <li nz-submenu nzTitle="{{'toi_uu_Chi_so_Ho_tro_tiep_can' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate">
          <mat-label>{{'mo_ta_ngan_gon_noi_dung' | translate}}<span style="color: red">*</span></mat-label>
          <textarea matInput
            [ngModel]="staticdata.accessibility?.['title_' + functionService.selectedLanguageCode] || 'Bản đồ'"
            (ngModelChange)="staticdata.accessibility['title_' + functionService.selectedLanguageCode] = $event"
            (blur)="updateContent('title', true);"></textarea>
        </mat-form-field>
      </li>
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <div class="button-size m-1 mt-2">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>
  <div class="view-more" *ngIf="isViewAll">
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['map__iframe']"
        [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
      </app-borders-radius-config>
    </div>
  </div>
</div>

<nz-modal [(nzVisible)]="isVisible" (nzOnCancel)="handleCancel()" [nzFooter]="null"
  [nzStyle]="{ height: '80vh', top: '32px', overflowY : 'scroll'}" [nzWidth]="'70%'">
  <ng-container *nzModalContent>
    <div class="modal-success">
      <h4 class="title">
        {{'huong_dan_khach_hang_chen_ban_do_vao_web' | translate}}
      </h4>
      <span>
        <i class="bi bi-x-lg"></i>
      </span>
      <div class="list-image">
        <div class="item-image">
          <img src="/assets/root/images/system/imgs/map_b1.jpg" alt="image 1">
          <div class="note-content">
            {{'buoc' | translate}} 1: {{'truy_cap_vao_duong_dan' | translate}} <a href="https://www.google.com/maps"
              target="_blank">https://www.google.com/maps</a>
          </div>
        </div>
        <div class="item-image">
          <img src="/assets/root/images/system/imgs/map_b1b2.jpg" alt="image 2">
          <div class="note-content">
            {{'buoc' | translate}} 2: {{'nhap_dia_chi_ban_muon_chia_se_hoac_chen_sau_khi_ban_do_da_chon_chinh_xac_vi_tri_ma_dia_chi_vua_nhap' | translate}}<span style="color:#00a859"> {{'nhan_vao' | translate}} <span style="font-weight: bold">{{'nut_chia_se' | translate}}.</span></span>
          </div>
        </div>

      </div>
      <div class="list-image pt-3">
        <div class="item-image">
          <img src="/assets/root/images/system/imgs/map_b1b3.jpg" alt="image 3">
          <div class="note-content">
            {{'buoc' | translate}} 3: {{'nhan_vao' | translate}} <span style="color: black">{{'tab_nhung_ban_do' | translate}}</span> <span
              style="color:#00a859; font-weight: bold;"> {{'va_nhan_nut_sao_chep_html' | translate}}.</span>
          </div>
        </div>
        <div class="item-image">
          <img src="/assets/root/images/system/imgs/map_b1b4.jpg" alt="image 4">
          <div class="note-content">
            {{'buoc' | translate}} 4: <span style="color:#00a859"> {{'dan_ma_nhung_vao_o_duong_dan_sau_do_nhan' | translate}} <span
                style="font-weight: bold;">{{'nut' | translate}} {{'cap_nhat' | translate}}</span> </span> {{'de_he_thong_lay_ban_do_ve' | translate}}.
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>